import React, { useRef, useContext } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { cloneDeep } from 'lodash';
import { useTranslation } from 'react-i18next';
import { CareUserContext } from './provider/careUserContext';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

const style = { cursor: 'move' };

export default function RenderOptionsItems({ column, index, parentIndex, id, columnEle, wholeArry }) {
  const ref = useRef(null);
  const { t } = useTranslation('common');
  const { state, setState } = useContext(CareUserContext);

  function swapArrayLocs(arr, index1, index2) {
    const temp = arr[index1];
    arr[index1] = arr[index2];
    arr[index2] = temp;
    return arr;
  }

  const moveOption = (dragIndex, hoverIndex) => {
    const currList = swapArrayLocs(columnEle?.options, dragIndex, hoverIndex);
    const copyState = cloneDeep(state?.addColumns);
    copyState[parentIndex].options = currList;
    setState((oldState) => ({
      ...oldState,
      addColumns: copyState,
    }));
  };

  const handleOptionChange = (value) => {
    const copyState = cloneDeep(state?.addColumns);
    copyState[parentIndex].options[index].name = value;
    copyState[parentIndex].hasError = false;
    setState((oldState) => ({
      ...oldState,
      addColumns: copyState,
    }));
  };

  const removeOption = () => {
    const copyState = cloneDeep(state?.addColumns);
    copyState[parentIndex].options.splice(index, 1);
    setState((oldState) => ({
      ...oldState,
      addColumns: copyState,
    }));
  };

  const addNewOptions = () => {
    const copyState = cloneDeep(state?.addColumns);
    copyState[parentIndex].options.push({ name: '' });
    setState((oldState) => ({
      ...oldState,
      addColumns: copyState,
    }));
  };

  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(ele, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = ele?.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref?.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveOption(dragIndex, hoverIndex);
      ele.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));
  return (
    <div className="mb-16 form-group d-flex" key={`${column?.Nmae}_${index}`} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      <div className=" pt-0 mb-0 common-input-control fixed-label">
        <input
          type="text"
          onChange={(e) => handleOptionChange(e.target.value)}
          placeholder={t('PIM_MODULE.COLUMN_MODAL.RENDER_LABEL_OPTIONS.PLEASE_ENTER_THE_OPTIONVALUE')}
          value={column?.name}
          maxLength="30"
          className="form-control text-bordered  "
        />
        {columnEle?.hasError && !column?.name && <span className="error-message">{t('PIM_MODULE.COLUMN_MODAL.RENDER_LABEL_OPTIONS.OPTION_REQUIRED')}</span>}
      </div>
      {(wholeArry?.length || 0) - 1 === index && (
        <CustomTooltip tooltipText={t('COMMON_LABEL.ADD')}>
          <button className="btn btn-outline sm m-0 ml-2" type="button" aria-label={t('COMMON_LABEL.ADD')} onClick={addNewOptions}>
            <span className="icon-Add f-20" />
          </button>
        </CustomTooltip>
      )}
      <CustomTooltip tooltipText={t('COMMON_LABEL.REARRANGE')}>
        <button className="btn btn-outline sm m-0 ml-2" id={column?.name} type="button" aria-label={t('COMMON_LABEL.REARRANGE')}>
          <span className="icon-Rearrange f-18" />
        </button>
      </CustomTooltip>
      {wholeArry?.length > 1 && (
        <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
          <button className="btn btn-outline sm m-0 ml-2" type="button" onClick={removeOption} aria-label={t('COMMON_LABEL.DELETE')}>
            <span className="icon-Delete f-20" />
          </button>
        </CustomTooltip>
      )}
    </div>
  );
}
